import { render, staticRenderFns } from "./studentContacts.vue?vue&type=template&id=224ff877&"
import script from "./studentContacts.vue?vue&type=script&lang=ts&"
export * from "./studentContacts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports